var _rect, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitzerlandPowerball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 15.126,
    cy: 8.278,
    r: 7.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#d7001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c00319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#840a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#760c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#6d0e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#5b1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95001a"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 14.488,
    cy: 7.17,
    r: 2.041,
    gradientTransform: "matrix(.6343 .7731 -1.1182 .9174 13.316 -10.608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f2eae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#f2e4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#f1d9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#f0c9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#efb5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#ee9d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8001a"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 15.126,
    cy: 26.273,
    r: 7.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#d7001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c00319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#840a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#760c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#6d0e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#5b1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95001a"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 14.488,
    cy: 25.164,
    r: 2.041,
    gradientTransform: "matrix(.6343 .7731 -1.1182 .9174 33.438 -9.123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f2eae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#f2e4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#f1d9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#f0c9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#efb5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#ee9d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8001a"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 6.089,
    cy: 17.191,
    r: 7.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#d7001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c00319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#840a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#760c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#6d0e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#5b1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95001a"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 5.45,
    cy: 16.083,
    r: 2.041,
    gradientTransform: "matrix(.6343 .7731 -1.1182 .9174 19.977 -2.886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f2eae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#f2e4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#f1d9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#f0c9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#efb5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#ee9d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8001a"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 24.101,
    cy: 17.276,
    r: 7.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#d7001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c00319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#840a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#760c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#6d0e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#5b1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95001a"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 23.463,
    cy: 16.167,
    r: 2.041,
    gradientTransform: "matrix(.6343 .7731 -1.1182 .9174 26.659 -16.805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f2eae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#f2e4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#f1d9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#f0c9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#efb5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#ee9d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8001a"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 25.841,
    cy: 17.153,
    r: 6.134,
    fx: 25.503,
    fy: 17.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ece9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#b5b0ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#a29a98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#8a7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#786968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#6e5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#6a5858"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.533 2.113c3.229 0 5.853 2.634 5.853 5.89s-2.624 5.891-5.853 5.891-5.853-2.633-5.853-5.89 2.615-5.891 5.853-5.891z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 3.359a2.54 2.54 0 0 1 2.53 2.54 2.532 2.532 0 0 1-2.53 2.539 2.54 2.54 0 0 1-2.53-2.54 2.532 2.532 0 0 1 2.53-2.54z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.533 19.106c3.229 0 5.853 2.633 5.853 5.89s-2.624 5.891-5.853 5.891-5.853-2.634-5.853-5.89 2.615-5.891 5.853-5.891z",
    fill: "url(#c)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 20.342a2.54 2.54 0 0 1 2.53 2.54 2.532 2.532 0 0 1-2.53 2.54 2.54 2.54 0 1 1 0-5.08z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.999 10.524c3.228 0 5.853 2.634 5.853 5.891s-2.625 5.89-5.853 5.89-5.853-2.633-5.853-5.89c0-3.247 2.615-5.89 5.853-5.89z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.536 11.77a2.54 2.54 0 1 1 0 5.08 2.54 2.54 0 1 1 0-5.08z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.001 10.61c3.229 0 5.853 2.633 5.853 5.89s-2.624 5.89-5.853 5.89-5.853-2.633-5.853-5.89 2.625-5.89 5.853-5.89z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.538 11.846a2.54 2.54 0 0 1 2.53 2.54 2.532 2.532 0 0 1-2.53 2.539 2.54 2.54 0 0 1-2.53-2.54c.01-1.397 1.142-2.54 2.53-2.54z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.153 19.899s.255-.973.387-2.172h-2.757l-.019-2.19 2.776.01c.085-.255-.293-1.823-.425-2.238 0 0 2.02-.094 2.02.01 0 .085.33.793.444 2.237l1.7.01s.084 2.17-.029 2.152c-.038 0-.746-.01-1.69-.01-.113 1.577-.396 2.21-.396 2.21l-2.011-.02z",
    fill: "url(#i)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerlandPowerball);
export default __webpack_public_path__ + "static/media/switzerland_powerball.248212c5077466b5934ca18dcd017da3.svg";
export { ForwardRef as ReactComponent };